import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import convertToFormErrors from 'utils/convertToFormErrors';
import Field from 'form/Field';
import Form from 'form/Form';
import Select from 'form/Select';
import SubmitButton from 'form/SubmitButton';
import { query, invalidateRequests } from 'redux-bees';
import { withRouter, Link } from 'react-router-dom';
import PlanInput from 'components/PlanInput';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';

@withRouter

@query('billingProfile', api.getBillingProfile)
@query('account', api.getAccount)
@query('plans', api.getPlans)

@reduxForm({
  form: 'ChangePlan',
  validate: generateFormValidation({
    recurrence: [validators.required()],
    plan: [validators.required()],
  }),
  initialValues: {
    recurrence: 'monthly',
  },
  onSubmit(values, dispatch, props) {
    return dispatch(api.createSitePlanChange(
      {
        data: {
          type: 'planChange',
          attributes: {
            recurrence: values.recurrence,
            coupon: values.coupon,
          },
          relationships: {
            plan: {
              data: { type: 'plan', id: values.plan },
            },
          },
        },
      },
    ))
    .then(() => {
      dispatch(invalidateRequests(api.getAccount));
      dispatch(invalidateRequests(api.getBillingProfile));
      dispatch(invalidateRequests(api.getInvoices));
    })
    .then(() => {
      props.history.push('/account');
      dispatch(notice('BillingInfo.success'));
    })
    .catch((response) => {
      dispatch(alert(response.body));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class ChangePlan extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
    plans: PropTypes.array,
    account: PropTypes.object,
    currentPlan: PropTypes.object,
    billingProfile: PropTypes.object,
    status: PropTypes.object,
  }

  render() {
    const {
      billingProfile,
      handleSubmit,
      submitting,
      error,
      plans,
      account,
      dirty,
      currentPlan,
      status,
    } = this.props;

    return (
      <Form error={error} onSubmit={handleSubmit}>
        <Field label="ChangePlan.plan" name="plan">
          {
            plans && account ?
              <PlanInput
                plans={plans}
                account={account}
                currentPlan={currentPlan}
                isCancelled={billingProfile && billingProfile.attributes.status === 'cancelled'}
              />
              :
              <span />
          }
        </Field>
        <div className="grid">
          <div className="grid__item width-8-12 space--bottom-2">
            <Field name="recurrence" label="ChangePlan.recurrence">
              <Select
                options={[
                  { value: 'yearly', label: 'Yearly billing (get 2 months free!)' },
                  { value: 'monthly', label: 'Monthly billing' },
                ]}
              />
            </Field>
          </div>
          <div className="grid__item width-4-12 space--bottom-2">
            <Field name="coupon" label="ChangePlan.coupon">
              <input type="text" />
            </Field>
          </div>
        </div>
        {
          !status.billingProfile.isLoading && !billingProfile &&
            <Link
              to={'/account/billing_profiles/edit_card'}
              className="button button--tiny"
            >
              Insert credit card
            </Link>
        }
        {
          !status.billingProfile.isLoading &&
            billingProfile &&
            (
              !billingProfile.attributes.addressLine ||
              !billingProfile.attributes.cardMaskedNumber
            ) &&
              <div className="grid space--bottom-2">
                {
                  !billingProfile.attributes.addressLine &&
                    <div className="grid__item width-6-12">
                      <div className="form__field">
                        <div className="form__label">Billing information</div>
                        <Link
                          to="/account/billing_profiles/edit?returnTo=/account/billing_profiles/change_plan"
                          className="button button--tiny"
                        >
                          Not present, please insert now
                        </Link>
                      </div>
                    </div>
                }
                {
                  !billingProfile.attributes.cardMaskedNumber &&
                    <div className="grid__item width-6-12">
                      <div className="form__field">
                        <div className="form__label">Credit card</div>
                        <Link
                          to="/account/billing_profiles/edit_card?returnTo=/account/billing_profiles/change_plan"
                          className="button button--tiny"
                        >
                          Not present, please insert now
                        </Link>
                      </div>
                    </div>
                }
              </div>
        }
        <SubmitButton
          dirty={dirty}
          className="button button--primary button--expand button--huge"
          submitting={submitting}
          label="ChangePlan.submit"
        />
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ChangePlan.jsx